<template>
  <div class="video-block section-padding">
    <div class="row">
      <div class="col-md-12">
        <div class="main-title">
          <VideoSort />
          <h6>My Channels</h6>
        </div>
      </div>
      <ChannelBig />
      <ChannelBig />
      <ChannelBig />
      <ChannelBig />
      <ChannelBig />
      <ChannelBig />
      <ChannelBig />
      <ChannelBig />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    VideoSort: () => import('@/components/video/VideoSort'),
    ChannelBig: () => import('@/components/channel/ChannelBig'),
  },
};
</script>
